"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "help-iconology-container" };
const _hoisted_2 = { class: "help-icons-column" };
const _hoisted_3 = { class: "help-icons-section-heading" };
const _hoisted_4 = { class: "help-icon-label" };
const _hoisted_5 = { class: "help-icon-label" };
const _hoisted_6 = { class: "help-icon-label" };
const _hoisted_7 = { class: "help-icon-label" };
const _hoisted_8 = { class: "help-icon-label" };
const _hoisted_9 = { class: "help-icon-label" };
const _hoisted_10 = { class: "help-icon-label" };
const _hoisted_11 = { class: "help-icon-label" };
const _hoisted_12 = { class: "help-icon-label" };
const _hoisted_13 = { class: "help-icon-label" };
const _hoisted_14 = { class: "help-icon-label" };
const _hoisted_15 = { class: "help-icon-label" };
const _hoisted_16 = { class: "help-icon-label" };
const _hoisted_17 = { class: "help-icon-sublabel" };
const _hoisted_18 = { class: "help-icon-label" };
const _hoisted_19 = { class: "help-icon-label" };
const _hoisted_20 = { class: "help-icon-label" };
const _hoisted_21 = { class: "help-icons-column" };
const _hoisted_22 = { class: "help-icons-section-heading" };
const _hoisted_23 = { class: "help-icon-sublabel" };
const _hoisted_24 = { class: "help-icon-label" };
const _hoisted_25 = { class: "help-icon-label" };
const _hoisted_26 = { class: "help-icon-label" };
const _hoisted_27 = { class: "help-icon-label" };
const _hoisted_28 = { class: "help-icon-label" };
const _hoisted_29 = { class: "help-icon-label" };
const _hoisted_30 = { class: "help-icon-sublabel" };
const _hoisted_31 = { class: "help-icon-label" };
const _hoisted_32 = { class: "help-icon-label" };
const _hoisted_33 = { class: "help-icon-label" };
const _hoisted_34 = { class: "help-icon-label" };
const _hoisted_35 = { class: "help-icon-label" };
const _hoisted_36 = { class: "help-icon-label" };
const _hoisted_37 = { class: "help-icon-label" };
const _hoisted_38 = { class: "help-icon-label" };
const _hoisted_39 = { class: "help-icons-column" };
const _hoisted_40 = { class: "help-icons-section-heading" };
const _hoisted_41 = { class: "help-icon-label" };
const _hoisted_42 = { class: "help-icon-label" };
const _hoisted_43 = { class: "help-icon-label" };
const _hoisted_44 = { class: "help-icon-label" };
const _hoisted_45 = { class: "help-icons-column" };
const _hoisted_46 = { class: "help-icons-section-heading" };
const _hoisted_47 = { class: "help-icon-label" };
const _hoisted_48 = { class: "help-icon-label" };
const _hoisted_49 = { class: "help-icon-label" };
const _hoisted_50 = { class: "help-icon-label" };
const _hoisted_51 = { class: "help-icons-column" };
const _hoisted_52 = { class: "help-icons-section-heading" };
const _hoisted_53 = { class: "help-icon-label" };
const _hoisted_54 = { class: "help-icon-label" };
const _hoisted_55 = { class: "help-icon-label" };
const _hoisted_56 = { class: "help-icon-label" };
const _hoisted_57 = { class: "help-icon-label" };
const _hoisted_58 = { class: "help-icon-label" };
const _hoisted_59 = { class: "help-icon-label" };
const _hoisted_60 = { class: "help-icon-label" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                        (0, vue_1.createTextVNode)("Card Tags", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[2] || (_cache[2] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-building" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                        (0, vue_1.createTextVNode)("Building", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[4] || (_cache[4] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-space" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                        (0, vue_1.createTextVNode)("Space", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[6] || (_cache[6] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-science" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6, [...(_cache[5] || (_cache[5] = [
                        (0, vue_1.createTextVNode)("Science", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[8] || (_cache[8] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-power" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7, [...(_cache[7] || (_cache[7] = [
                        (0, vue_1.createTextVNode)("Power", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[10] || (_cache[10] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-earth" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8, [...(_cache[9] || (_cache[9] = [
                        (0, vue_1.createTextVNode)("Earth", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[12] || (_cache[12] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-jovian" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_9, [...(_cache[11] || (_cache[11] = [
                        (0, vue_1.createTextVNode)("Jovian", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[14] || (_cache[14] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-venus" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_10, [...(_cache[13] || (_cache[13] = [
                        (0, vue_1.createTextVNode)("Venus", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[15] || (_cache[15] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-venus" }, null, -1))
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[17] || (_cache[17] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-plant" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_11, [...(_cache[16] || (_cache[16] = [
                        (0, vue_1.createTextVNode)("Plant", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[19] || (_cache[19] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-microbe" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_12, [...(_cache[18] || (_cache[18] = [
                        (0, vue_1.createTextVNode)("Microbe", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[21] || (_cache[21] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-animal" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_13, [...(_cache[20] || (_cache[20] = [
                        (0, vue_1.createTextVNode)("Animal", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[23] || (_cache[23] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-city" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_14, [...(_cache[22] || (_cache[22] = [
                        (0, vue_1.createTextVNode)("City", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            _cache[41] || (_cache[41] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[25] || (_cache[25] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-wild" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_15, [...(_cache[24] || (_cache[24] = [
                        (0, vue_1.createTextVNode)("Wild", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[26] || (_cache[26] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-prelude" }, null, -1)),
                _cache[27] || (_cache[27] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-colony" }, null, -1)),
                _cache[28] || (_cache[28] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-turmoil" }, null, -1))
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[30] || (_cache[30] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-event" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_16, [...(_cache[29] || (_cache[29] = [
                        (0, vue_1.createTextVNode)("Event", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            _cache[42] || (_cache[42] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_17, [...(_cache[31] || (_cache[31] = [
                        (0, vue_1.createTextVNode)("Fan Expansion Tags", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[33] || (_cache[33] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-moon" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_18, [...(_cache[32] || (_cache[32] = [
                        (0, vue_1.createTextVNode)("Moon", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[34] || (_cache[34] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-themoon" }, null, -1))
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[36] || (_cache[36] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-mars" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_19, [...(_cache[35] || (_cache[35] = [
                        (0, vue_1.createTextVNode)("Mars", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[37] || (_cache[37] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-pathfinders" }, null, -1))
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[39] || (_cache[39] = (0, vue_1.createElementVNode)("div", { class: "resource-tag tag-clone" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_20, [...(_cache[38] || (_cache[38] = [
                        (0, vue_1.createTextVNode)("Clone", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[40] || (_cache[40] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-pathfinders" }, null, -1))
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_21, [
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_22, [...(_cache[43] || (_cache[43] = [
                        (0, vue_1.createTextVNode)("Resources", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_23, [...(_cache[44] || (_cache[44] = [
                        (0, vue_1.createTextVNode)("Standard Resources", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[46] || (_cache[46] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource money" }, [
                    (0, vue_1.createElementVNode)("div", { class: "help-icon-mc-font" }, "€")
                ], -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_24, [...(_cache[45] || (_cache[45] = [
                        (0, vue_1.createTextVNode)("MegaCredits (M€)", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[48] || (_cache[48] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource steel" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_25, [...(_cache[47] || (_cache[47] = [
                        (0, vue_1.createTextVNode)("Steel", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[50] || (_cache[50] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource titanium" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_26, [...(_cache[49] || (_cache[49] = [
                        (0, vue_1.createTextVNode)("Titanium", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[52] || (_cache[52] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource plant" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_27, [...(_cache[51] || (_cache[51] = [
                        (0, vue_1.createTextVNode)("Plant", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[54] || (_cache[54] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource energy" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_28, [...(_cache[53] || (_cache[53] = [
                        (0, vue_1.createTextVNode)("Energy", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[56] || (_cache[56] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource heat" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_29, [...(_cache[55] || (_cache[55] = [
                        (0, vue_1.createTextVNode)("Heat", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            _cache[79] || (_cache[79] = (0, vue_1.createElementVNode)("br", null, null, -1)),
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_30, [...(_cache[57] || (_cache[57] = [
                        (0, vue_1.createTextVNode)("Resources on Cards", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[59] || (_cache[59] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource animal" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_31, [...(_cache[58] || (_cache[58] = [
                        (0, vue_1.createTextVNode)("Animal", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[61] || (_cache[61] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource microbe" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_32, [...(_cache[60] || (_cache[60] = [
                        (0, vue_1.createTextVNode)("Microbe", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[63] || (_cache[63] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource science" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_33, [...(_cache[62] || (_cache[62] = [
                        (0, vue_1.createTextVNode)("Science", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[65] || (_cache[65] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource floater" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_34, [...(_cache[64] || (_cache[64] = [
                        (0, vue_1.createTextVNode)("Floater", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[67] || (_cache[67] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource asteroid" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_35, [...(_cache[66] || (_cache[66] = [
                        (0, vue_1.createTextVNode)("Asteroid", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[68] || (_cache[68] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-venus" }, null, -1)),
                _cache[69] || (_cache[69] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-promo" }, null, -1))
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[71] || (_cache[71] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource preservation" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_36, [...(_cache[70] || (_cache[70] = [
                        (0, vue_1.createTextVNode)("Preservation", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[72] || (_cache[72] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-turmoil" }, null, -1))
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[74] || (_cache[74] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource camp" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_37, [...(_cache[73] || (_cache[73] = [
                        (0, vue_1.createTextVNode)("Camp", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[75] || (_cache[75] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-colony" }, null, -1))
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[77] || (_cache[77] = (0, vue_1.createElementVNode)("div", { class: "help-icon-resource disease" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_38, [...(_cache[76] || (_cache[76] = [
                        (0, vue_1.createTextVNode)("Disease", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _cache[78] || (_cache[78] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-promo" }, null, -1))
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_39, [
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_40, [...(_cache[80] || (_cache[80] = [
                        (0, vue_1.createTextVNode)("Tiles", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[82] || (_cache[82] = (0, vue_1.createElementVNode)("div", { class: "tile greenery-no-O2-tile" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_41, [...(_cache[81] || (_cache[81] = [
                        (0, vue_1.createTextVNode)("Greenery", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[84] || (_cache[84] = (0, vue_1.createElementVNode)("div", { class: "tile city-tile" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_42, [...(_cache[83] || (_cache[83] = [
                        (0, vue_1.createTextVNode)("City", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[86] || (_cache[86] = (0, vue_1.createElementVNode)("div", { class: "tile ocean-tile" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_43, [...(_cache[85] || (_cache[85] = [
                        (0, vue_1.createTextVNode)("Ocean", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[88] || (_cache[88] = (0, vue_1.createElementVNode)("div", { class: "tile special-tile" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_44, [...(_cache[87] || (_cache[87] = [
                        (0, vue_1.createTextVNode)("Special", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_45, [
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_46, [...(_cache[89] || (_cache[89] = [
                        (0, vue_1.createTextVNode)("Global Parameters", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[91] || (_cache[91] = (0, vue_1.createElementVNode)("div", { class: "tile help-icon-param-box-temperature" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_47, [...(_cache[90] || (_cache[90] = [
                        (0, vue_1.createTextVNode)("Temperature", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[93] || (_cache[93] = (0, vue_1.createElementVNode)("div", { class: "tile help-icon-param-box-oxygen" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_48, [...(_cache[92] || (_cache[92] = [
                        (0, vue_1.createTextVNode)("Oxygen", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[95] || (_cache[95] = (0, vue_1.createElementVNode)("div", { class: "tile help-icon-param-box-ocean" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_49, [...(_cache[94] || (_cache[94] = [
                        (0, vue_1.createTextVNode)("Oceans", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[97] || (_cache[97] = (0, vue_1.createElementVNode)("div", { class: "tile help-icon-param-box-venus" }, null, -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_50, [...(_cache[96] || (_cache[96] = [
                        (0, vue_1.createTextVNode)("Venus", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_51, [
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_52, [...(_cache[98] || (_cache[98] = [
                        (0, vue_1.createTextVNode)("Others", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[100] || (_cache[100] = (0, vue_1.createElementVNode)("div", { class: "help-other-symbols" }, [
                    (0, vue_1.createElementVNode)("div", { class: "help-icon-victory-point" }, "?")
                ], -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_53, [...(_cache[99] || (_cache[99] = [
                        (0, vue_1.createTextVNode)("Victory Point (VP)", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[102] || (_cache[102] = (0, vue_1.createElementVNode)("div", { class: "help-other-symbols" }, [
                    (0, vue_1.createElementVNode)("div", { class: "tile rating" })
                ], -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_54, [...(_cache[101] || (_cache[101] = [
                        (0, vue_1.createTextVNode)("Terraform Rating (TR)", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[104] || (_cache[104] = (0, vue_1.createElementVNode)("div", { class: "help-other-symbols" }, [
                    (0, vue_1.createElementVNode)("div", { class: "help-icon-card card" })
                ], -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_55, [...(_cache[103] || (_cache[103] = [
                        (0, vue_1.createTextVNode)("Project Card", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[106] || (_cache[106] = (0, vue_1.createElementVNode)("div", { class: "help-other-symbols" }, [
                    (0, vue_1.createElementVNode)("div", { class: "tile colony" })
                ], -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_56, [...(_cache[105] || (_cache[105] = [
                        (0, vue_1.createTextVNode)("Colony", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[108] || (_cache[108] = (0, vue_1.createElementVNode)("div", { class: "help-other-symbols" }, [
                    (0, vue_1.createElementVNode)("div", { class: "tile trade" })
                ], -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_57, [...(_cache[107] || (_cache[107] = [
                        (0, vue_1.createTextVNode)("Trade", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[110] || (_cache[110] = (0, vue_1.createElementVNode)("div", { class: "help-other-symbols" }, [
                    (0, vue_1.createElementVNode)("div", { class: "tile fleet" })
                ], -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_58, [...(_cache[109] || (_cache[109] = [
                        (0, vue_1.createTextVNode)("Trade Fleet", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[112] || (_cache[112] = (0, vue_1.createElementVNode)("div", { class: "help-other-symbols" }, [
                    (0, vue_1.createElementVNode)("div", { class: "help-icon-delegate" })
                ], -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_59, [...(_cache[111] || (_cache[111] = [
                        (0, vue_1.createTextVNode)("Delegate", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.createElementVNode)("div", null, [
                _cache[114] || (_cache[114] = (0, vue_1.createElementVNode)("div", { class: "help-other-symbols" }, [
                    (0, vue_1.createElementVNode)("div", { class: "help-icon-influence influence" })
                ], -1)),
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_60, [...(_cache[113] || (_cache[113] = [
                        (0, vue_1.createTextVNode)("Influence", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ])
    ]));
}
